import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private http: HttpClient) {}

  checkPublishStatus() {
    return this.http.get<any>(environment.reportUrl+ ApiPaths.checkPublishStatus).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }


  getAllPSRGroupsList() {
    return this.http.get<any>(environment.reportUrl+ ApiPaths.getAllPSRGroups).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }  

  revokePsrAccess() {
    return this.http.get<any>(environment.reportUrl+ ApiPaths.revokePsrAccess).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }  

  saveProject(payload:any): Observable<any> {
    return this.http.post<any>(environment.apiUrl+ ApiPaths.saveProjectDetails, payload ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  createProject(payload:any): Observable<any> {
    return this.http.post<any>(environment.apiUrl+ ApiPaths.createProject, payload ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getAllProjects(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getProjects).pipe(
      map((res: AppResponse) => {
        return res;
      })
    )
  }
  
  publishPSRGroups(payload:any): Observable<any> {
    return this.http.post<any>(environment.reportUrl+ ApiPaths.publishWeeklyPSRReports, payload ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }
  
  revokePSRGroups(payload:any): Observable<any> {
    return this.http.post<any>(environment.reportUrl+ ApiPaths.revokePSRGroups, payload ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  lastAccessedByReport(): Observable<any> {
    return this.http.get<any>(environment.reportUrl+ ApiPaths.lastAccessedByReport).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

}




export interface PublishData{
  weekendingDt: Date|null|string,
  reportName: string,
  recipientName: string,
  recipientEmail: string,
  publishedBy: string,
  publishedOn: Date,
  lastAccessedDate: Date,
  accessRevokedFlag: string
}

export function PublishDataConversion(data:any[]){

  if(!data || !data.length)
    return [];

  let res:PublishData[]=[];

  for(let d of data){
    let temp:PublishData={
      weekendingDt: d.weekendingDt,
      reportName: d.reportName,
      recipientName: d.recipientName,
      recipientEmail: d.recipientEmail,
      publishedBy: d.publishedBy,
      publishedOn: d.publishedOn,
      lastAccessedDate: d.lastAccessedDate,
      accessRevokedFlag: d.accessRevokedFlag==true?"YES":"NO"
    }
    res.push(temp);
  }

  return res;

}